import React from "react";
import { useSelector } from "react-redux";
import { Datos } from "./Datos";
import { Spinner } from "./_Spinner";
import { Button, Modal } from "antd";

export const ModalDetalle = ({ open, setOpen }) => {
  const { asistencia, loadingDetalle } = useSelector(
    (state) => state.asistenciasReducer
  );

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      titulo={`Datos de Asistencia ${asistencia.asistenciaID}`}
      footer={[
        <Button onClick={() => setOpen(false)} size="small">
          cerrar
        </Button>,
      ]}
    >
      {loadingDetalle ? <Spinner /> : <Datos />}
    </Modal>
  );
};
